import { ProductTypes } from "../constants/ProductTypes";

export const normalizeProductTypeForWishlistRemoval = (type: string) => {
  const {
    BLUETOOTH_HEADPHONE,
    JEWLERY,
    PURSE,
    CHARGER,
    MEMORY,
    HEADPHONE,
    ACCESSORY,
    WATCH,
    SMART_BAND,
    MYKI,
  } = ProductTypes;

  const accessories: string[] = [
    BLUETOOTH_HEADPHONE,
    JEWLERY,
    PURSE,
    CHARGER,
    MEMORY,
    HEADPHONE,
    ACCESSORY,
  ];

  const watches: string[] = [MYKI, WATCH, SMART_BAND];

  if (accessories.includes(type)) {
    return ProductTypes.ACCESSORY;
  }

  if (watches.includes(type)) {
    return ProductTypes.WATCH;
  }

  return type;
};
